import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes } from "date-fns";

import { type TimesheetEntry } from "../hooks/useTimesheetEntry";

interface CalculateHasPendingHoursAdjustmentRequest {
  verifiedTimesheet: TimesheetEntry;
  adjustedTimesheet: TimesheetEntry;
}

/**
 * Returns true when the adjusted timesheet claims more paid minutes than the
 * verified (original) timesheet — meaning the worker's extra-worked-time
 * request is genuinely adding hours that need facility approval.
 */
export function calculateHasPendingHoursAdjustment({
  verifiedTimesheet,
  adjustedTimesheet,
}: CalculateHasPendingHoursAdjustmentRequest): boolean {
  const verifiedBreakMinutes =
    isDefined(verifiedTimesheet.breakStartTime) && isDefined(verifiedTimesheet.breakEndTime)
      ? differenceInMinutes(verifiedTimesheet.breakEndTime, verifiedTimesheet.breakStartTime)
      : 0;
  const verifiedMinutes =
    differenceInMinutes(verifiedTimesheet.clockOutTime, verifiedTimesheet.clockInTime) -
    verifiedBreakMinutes;

  const adjustedBreakMinutes =
    isDefined(adjustedTimesheet.breakStartTime) && isDefined(adjustedTimesheet.breakEndTime)
      ? differenceInMinutes(adjustedTimesheet.breakEndTime, adjustedTimesheet.breakStartTime)
      : 0;
  const adjustedMinutes =
    differenceInMinutes(adjustedTimesheet.clockOutTime, adjustedTimesheet.clockInTime) -
    adjustedBreakMinutes;

  return adjustedMinutes > verifiedMinutes;
}
